import "./style.css";
import Phaser from "phaser";
import { MenuScene } from "./menu/scene";
import { GAMES } from "./games/registry";

const sizeFromViewport = () => {
  const w = Math.min(window.innerWidth, document.documentElement.clientWidth);
  const h = Math.min(window.innerHeight, document.documentElement.clientHeight);
  return { width: w, height: h };
};

const { width, height } = sizeFromViewport();

new Phaser.Game({
  type: Phaser.AUTO,
  parent: "app",
  width,
  height,
  backgroundColor: "#f5e6d3",
  // dom.createContainer enables this.add.dom() — used for overlay buttons so
  // text is browser-crisp on retina and taps are native, not Phaser-mediated.
  dom: { createContainer: true },
  scale: {
    mode: Phaser.Scale.RESIZE,
    autoCenter: Phaser.Scale.CENTER_BOTH,
  },
  physics: {
    default: "matter",
    matter: {
      gravity: { x: 0, y: 0 },
      debug: false,
    },
  },
  scene: [MenuScene, ...GAMES.flatMap((g) => g.scenes)],
  fps: { target: 60, smoothStep: true },
  input: { activePointers: 3 },
});
